module.exports = __webpack_public_path__ + "img/20200122124913964.795cef88.jpg";